export default class EnvHelper {
    static get env() {
        return craft.env;
    }

    static get devMode() {
        return craft.env.devMode;
    }

    static get currentCityId() {
        return costorage.get('h_city') ? costorage.get('h_city') :
            (costorage.get('h_geo') ? costorage.get('h_geo') : 'online');
    }

    static get isSchoolCityOther() {
        return craft.env.cityId && craft.env.cityId.indexOf('ua') === 0;
    }

    static get cityInfo() {
        const cityInfoList = craft.env.cityInfo;

        if (cityInfoList) {
            return cityInfoList.find(({ id }) => id === EnvHelper.currentCityId);
        }
    }

    static get siteName() {
        return craft.env.siteName;
    }

    static get siteLang() {
        return craft.env.siteLang;
    }

    static get page() {
        return craft.page;
    }
}